<template>
  <div class="search-section">
    <div class="search-wrapper">
      <div class="search-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
      </div>
      <input 
        v-model="searchQuery" 
        @input="$emit('search', searchQuery)"
        placeholder="Search articles, topics, keywords..."
        class="search-input"
        type="text"
      />
      <div v-if="searchQuery" class="clear-button" @click="clearSearch">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'SearchBar',
  data() {
    return {
      searchQuery: '',
    };
  },
  methods: {
    clearSearch() {
      this.searchQuery = '';
      this.$emit('search', '');
    }
  }
};
</script>

<style scoped>
.search-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-2xl) var(--spacing-lg);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.search-wrapper {
  position: relative;
  width: 100%;
  max-width: 700px;
}

.search-input {
  width: 100%;
  padding: var(--spacing-lg) var(--spacing-xl);
  padding-left: 60px;
  padding-right: 60px;
  font-size: var(--font-size-lg);
  font-weight: 500;
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-2xl);
  outline: none;
  transition: all var(--transition-base);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.search-input::placeholder {
  color: var(--text-muted);
  font-weight: 400;
}

.search-input:focus {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(102, 126, 234, 0.5);
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.2),
              0 0 0 4px rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.search-icon {
  position: absolute;
  left: var(--spacing-lg);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  transition: all var(--transition-base);
}

.search-input:focus ~ .search-icon,
.search-input:focus + div + .search-icon {
  color: var(--primary-color);
}

/* Since CSS sibling selectors work forward, we need to adjust */
.search-wrapper:focus-within .search-icon {
  color: var(--primary-color);
  transform: translateY(-50%) scale(1.1);
}

.clear-button {
  position: absolute;
  right: var(--spacing-lg);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-xs);
  border-radius:50%;
  transition: all var(--transition-fast);
}

.clear-button:hover {
  color: var(--error-color);
  background: rgba(239, 83, 80, 0.1);
  transform: translateY(-50%) rotate(90deg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-section {
    padding: var(--spacing-xl) var(--spacing-md);
  }

  .search-input {
    font-size: var(--font-size-base);
    padding: var(--spacing-md) var(--spacing-lg);
    padding-left: 50px;
    padding-right: 50px;
  }

  .search-icon {
    left: var(--spacing-md);
  }

  .clear-button {
    right: var(--spacing-md);
  }
}

@media (max-width: 480px) {
  .search-section {
    padding: var(--spacing-lg) var(--spacing-sm);
  }

  .search-input {
    font-size: var(--font-size-sm);
  }
}
</style>